import React from 'react';
import { BaseTypography } from './BaseTypography';

type PModernTitle = {
  title: string | any;
  className?: any;
};

export const ModernTitle: React.FC<PModernTitle> = (props) => {
  const { title, className } = props;
  return (
    <BaseTypography
      variant="h2"
      style={{ marginBottom: '20px' }}
      className={className}
    >
      {title}
    </BaseTypography>
  );
};
